import { CommonModule } from '@angular/common';
import { Component, effect, Inject, inject, Input } from '@angular/core';

import { SvgIconComponent } from '../../../components';
import { ButtonComponent } from '../../../components/buttons/button/button.component';
import { ClientUserService, ProUserService } from '../../../services';
import { IconNames } from '../../../shared';
import { GlobalsInterface } from '../../../types';

@Component({
    selector: 'lib-empty-state',
    standalone: true,
    imports: [CommonModule, SvgIconComponent, ButtonComponent],
    templateUrl: './empty-state.component.html',
    styleUrl: './empty-state.component.css'
})
export class EmptyStateComponent {
    clientUserService = inject(ClientUserService);
    proUserService = inject(ProUserService);

    @Input() iconName!: IconNames;
    @Input() title!: string;
    @Input() description!: string;
    @Input() userType: 'client' | 'pro' = 'client';
    @Input() registerPath: string = '/register';
    @Input() loginPath: string = '/login';
    @Input() browsePath: string = '/jobs/new';

    isLoggedIn: boolean = false;

    constructor(@Inject('globals') globals: GlobalsInterface) {
        effect(() => {
            this.isLoggedIn =
                globals.appType === 'client'
                    ? this.clientUserService.isLoggedIn()
                    : globals.appType === 'pro'
                      ? this.proUserService.isLoggedIn()
                      : false;
        });
    }
}
